import useRepository from "@@/composables/useRepository.js";
const resource = "auth";

export const check = () => {
	return useRepository().getRaw(`${resource}/me`);
};

export const login = (credentials) => {
	return useRepository().post(`${resource}/login`, {
		email: credentials.email,
		password: credentials.password,
		remember: credentials.remember,
	});
};

export const logout = () => {
	return useRepository().post(`${resource}/logout`);
};

export const passwordForgot = (data) => {
	return useRepository().post(`${resource}/password-forget`, {
		email: data.email,
	});
};

export const passwordReset = (data) => {
	return useRepository().post(`${resource}/password-reset`, {
		token: data.token,
		email: data.email,
		password: data.password,
		password_confirmation: data.password_confirmation,
	});
};

export const verification2fa = (data) => {
	return useRepository().post(`${resource}/two-step-verification`, {
		token: data.token,
		code: data.code,
	});
};

export const update = (data) => {
	return useRepository().put(`${resource}/me`, data);
};

export default { check, login, logout, passwordForgot, passwordReset, update, verification2fa };
